var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeechBubble = function SvgIconSpeechBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.25 4.016A8 8 0 0 0 4.87 16.083a.5.5 0 0 1 .025.464l-1.894 4.13a.207.207 0 0 0 .226.235l3.954-2.047a.5.5 0 0 1 .485.014A8 8 0 1 0 12.25 4.016m-6.021.877A9 9 0 1 1 7.4 19.879L3.63 21.83a.5.5 0 0 1-.095.037 1.207 1.207 0 0 1-1.489-1.489 1 1 0 0 1 .027-.073l1.808-3.942A9 9 0 0 1 6.229 4.893",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeechBubble;